import { render, staticRenderFns } from "./CalcResults.vue?vue&type=template&id=561893d9&"
import script from "./CalcResults.vue?vue&type=script&lang=js&"
export * from "./CalcResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports